export const formatTestId = (prefix: string, id: string) => {
  const formattedId = id.toLowerCase().replaceAll(' ', '_');
  return `${prefix}_${formattedId}`;
};
